import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Careers.css";
import { jobPostings } from "../data/jobPostings";
import { Helmet } from "react-helmet";

function Careers() {
  const navigate = useNavigate();
  const [, setSelectedJob] = useState("");

  const handleJobClick = (item) => {
    setSelectedJob(item);
    navigate("/job-application", { state: { job: item } });
  };

  return (
    <>
      <Helmet>
        <title>Careers at Jaxum | Join Our Team</title>
        <meta
          name="description"
          content="Explore career opportunities at Jax Utilities Management. Join our team of construction and utilities professionals in Jacksonville."
        />
        <meta
          property="og:title"
          content="Careers at Jax Utilities Management | Join Our Team"
        />
        <meta
          property="og:description"
          content="Find your next career opportunity at Jax Utilities Management. Join our growing team in Jacksonville."
        />
        <meta
          property="og:image"
          content="https://jum-email-signature.s3.us-east-2.amazonaws.com/JAXUM+Logo+(bold+est).png"
        />
        <meta property="og:url" content="https://www.jaxum.com/careers" />
        <link rel="canonical" href="https://www.jaxum.com/careers" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Careers at Jax Utilities Management | Join Our Team"
        />
        <meta
          name="twitter:description"
          content="Find your next career opportunity at Jax Utilities Management. Join our growing team in Jacksonville."
        />
        <meta
          name="twitter:image"
          content="https://jum-email-signature.s3.us-east-2.amazonaws.com/JAXUM+Logo+(bold+est).png"
        />
      </Helmet>
      <div className="career-container">
        <div className="career-content">
          <h1 className="career-title">
            Job Application for Jax Utilities Management
          </h1>

          <div className="job-container">
            {jobPostings.map((item, index) => (
              // <a className="job-link" href="J" target="_blank">
              <div
                className="job-content"
                onClick={() => handleJobClick(item)}
                key={index}
              >
                <div className="job-header">
                  <h2 className="job-title">{item.name}</h2>
                  <p className="job-crew">{item.crew}</p>
                </div>

                <img
                  className="job-arrow"
                  src="../assets/arrow-right.svg"
                  alt="View job"
                />
              </div>
              // </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Careers;
